import { cn } from '@/utils/cn';
import { initialsOf } from '@/utils/format';

interface AvatarProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-base',
};

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const cls = cn(
    'inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-primary-500 via-indigo-500 to-sky-500 font-semibold text-white ring-2 ring-white shadow-soft',
    sizeClasses[size],
    className,
  );
  if (src) {
    return (
      <span className={cls}>
        <img
          src={src}
          alt={name}
          className="h-full w-full object-cover"
          loading="lazy"
        />
      </span>
    );
  }
  return <span className={cls}>{initialsOf(name)}</span>;
}
